import { F0, TypedValue } from '@client/new/helpers/types';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

export type ViewNotification = TypedValue<
  'Success' | 'Error' | 'Custom',
  string
>;

export type NotificationsVM = {
  data: ViewNotification[];
  clearNotifications: F0;
};

export const useNotificationsModel = () => {
  const [data, setData] = useState<Array<ViewNotification>>([]);

  const pushNotification = (
    type: ViewNotification['type'],
    value: ViewNotification['value'],
  ) => {
    setData((prev) => [...prev, { type, value }]);
    return null;
  };

  return { pushNotification, data, clearNotifications: () => setData([]) };
};

export const useToastEffect = (p: NotificationsVM) => {
  const e = useEffect(() => {
    if (p.data.length === 0) return;
    p.data.forEach((n) => {
      switch (n.type) {
        case 'Success':
          return toast.success(n.value);
        case 'Custom':
          return toast.success(n.value);
        case 'Error':
          return toast.error(n.value);
      }
    });
    p.clearNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [p.data]);
  return e;
};
